module.exports = __webpack_public_path__ + "static/media/Spinner.0ed2fb80.svg";